import { View } from 'react-native'
import Page from '@shell/Page'
import { DevActions } from 'utils/dev/DevActions'

export default function DevPage() {
  return (
    <Page stage="dev">
      <View className="flex gap-8 p-16">
        <DevActions />
      </View>
    </Page>
  )
}
